import React, { useEffect, useState } from 'react'
import {
  Input,
  Form,
  Col,
  Button,
  message,
  Table,
  Row,
  Tooltip,
  Popconfirm,
} from 'antd'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import Layouts from '../components/Layouts'
import apiRequest from '../hooks/ApiRequest'

const CurrencyConversion = props => {
  const { form } = props
  const { getFieldDecorator, setFieldsValue, resetFields, validateFields } = form

  const [currencyList, setCurrencyList] = useState([])
  const [currencyId, setCurrencyId] = useState(0)
  const [editRecord, setEditRecord] = useState(null)
  const LoginInsurerId = JSON.parse(localStorage.getItem('loggedInUserID'))

  const columns = [
    {
      key: '1',
      title: 'Currency Name',
      dataIndex: 'currencyName',
    },
    {
      key: '2',
      title: 'Currency Code',
      dataIndex: 'currencyCode',
    },
    {
      key: '3',
      title: 'Conversion Rate',
      dataIndex: 'conversionRate',
    },
    {
      key: '4',
      title: 'Action',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              type="primary"
              className="edit_btn"
              onClick={() => handleEditCurrency(record)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            className="delete_btn"
            title="Are you sure you want to delete this record ?"
            onConfirm={() => handleDeleteCurrency(record.id)}
          >
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]


  const fetchCurrencies = async () => {
    try {

      const loggedInInsurerId = localStorage.getItem("insurerId");
      if (!loggedInInsurerId) {
        message.error("Logged in insurer not found!");
        return;
      }

      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetCurrenciesByInsurer/GetCurrency/${loggedInInsurerId}`,
        "GET"
      );

      if (response.success) {
        setCurrencyList(response.data.data || []);
      } else {
        message.error(response.message || "No currencies found!");
      }
    } catch (error) {
      console.error("Fetch Currencies Error:", error);
      message.error("Failed to fetch currencies!");
    }
  };


  useEffect(() => {
    fetchCurrencies()
  }, [])

  useEffect(() => {
    if (editRecord && editRecord.id === currencyId) {
      setFieldsValue({
        currencyName: editRecord.currencyName,
        currencyCode: editRecord.currencyCode,
        conversionRate: editRecord.conversionRate,
      })
    }
  }, [currencyId, editRecord])

  const handleEditCurrency = record => {
    setEditRecord(record)
    setCurrencyId(record.id)
  }

  const handleDeleteCurrency = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/DeleteCurrency/${id}`,
        'POST'
      )
      if (res.success) {
        message.success('Currency Deleted Successfully!')
        fetchCurrencies()
      } else {
        message.error('Failed to delete currency.')
      }
    } catch (error) {
      console.error('Delete Currency Error:', error)
      message.error('Failed to delete currency!')
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const values = await validateFields()
      const { currencyName, currencyCode, conversionRate } = values

      const payload = {
        id: currencyId,
        currencyName,
        insurerId: LoginInsurerId,
        currencyCode,
        conversionRate: parseFloat(conversionRate),
        ModifiedBy: String(LoginInsurerId),
      }

      const url = currencyId
        ? `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/UpdateCurrency/${currencyId}`
        : `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/CreateCurrency`

      const response = await apiRequest(url, 'POST', payload)

      if (response.success) {
        message.success(
          currencyId ? 'Currency Updated Successfully!' : 'Currency Added Successfully!'
        )
        resetFields()
        setCurrencyId(0)
        fetchCurrencies()
      } else {
        message.error('Something went wrong!')
      }
    } catch (error) {
      console.error('Submit Currency Error:', error)
      message.error('Failed to process request!')
    }
  }

  return (
    <Layouts title="Currency Conversion" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <div className="section-top-heading">
              <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Currency Conversion Rates
              </h3>
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <Row className="m-t-30 m-b-40">
          <div className="dash-bg-white" style={{ padding: '20px', width: '100%' }}>
            <Form layout="vertical" onSubmit={handleSubmit}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={6}>
                  <Form.Item label="Currency Name">
                    {getFieldDecorator('currencyName', {
                      rules: [{ required: true, message: 'Please enter currency name' }],
                    })(<Input placeholder="Enter Currency Name" />)}
                  </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                  <Form.Item label="Currency Code">
                    {getFieldDecorator('currencyCode', {
                      rules: [{ required: true, message: 'Please enter currency code' }],
                    })(<Input placeholder="Enter Currency Code" />)}
                  </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                  <Form.Item label="Conversion Rate">
                    {getFieldDecorator('conversionRate', {
                      rules: [
                        { required: true, message: 'Please enter conversion rate' },
                        {
                          validator: (_, value, cb) => {
                            if (!value) {
                              cb()
                            } else if (Number(value) <= 0) {
                              cb('Conversion rate must be greater than 0')
                            } else {
                              cb()
                            }
                          },
                        },
                      ],
                    })(<Input type="number" min={0} step="0.01" placeholder="Enter Rate" />)}
                  </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                  <Button htmlType="submit" className="primary m-t-22" block>
                    {currencyId ? 'Update Rate' : 'Add Rate'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>

          <div className="table-grid-bx">
            <Table
              className="table-scroll-auto"
              columns={columns}
              dataSource={currencyList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </Row>
      </div>
    </Layouts>
  )
}

export default Form.create()(CurrencyConversion)
